/**
 * True when the throw site (last frame; oldest call first) is a browser-extension script -
 * a third-party extension, since ours never runs on our site. Frames beneath it are ignored,
 * so an extension patch that throws on a call from our code is also dropped.
 *
 * Self-contained and legacy-safe (no arrow fns, no `??`) so `.toString()` can inline it
 * into a server-rendered snippet.
 */
// eslint-disable-next-line func-style -- a declaration keeps .toString() output stable
export function isExtensionThrownStackTrace(frameUrls: Array<string | null | undefined> | null | undefined): boolean {
    if (!frameUrls || frameUrls.length === 0) return false;

    const throwSiteUrl = frameUrls[frameUrls.length - 1] || '';

    return /^[a-z-]+-extension:\/\//i.test(throwSiteUrl);
}
